import styled from 'styled-components';
import { AnalysisSection } from '../styled';

export const FunnelChartContainer = styled(AnalysisSection)`
  box-sizing: border-box;
  height: 485px;
  display: flex;
  flex-direction: column;
`;

export const FunnelChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex: none;
`;

export const FunnelChartTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
`;

export const FunnelChartControls = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  .gm-ant-select {
    margin-left: 8px;
    width: 150px;
  }
`;
